
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import dynamic from 'next/dynamic';
import { LoaderScreen } from '@/components/elements/LoaderScreen';
import { MainLayout } from '@/components/layouts/MainLayout';
import { createNonLocalizedPageGetServerSideProps } from '@/helpers/createNonLocalizedPageGetServerSideProps';
const CookiePolicy = dynamic(async () => await import('@/templates/CookiePolicy/CookiePolicy'), {
    loading: LoaderScreen,
});
const cookie = () => {
    return (<MainLayout title='Cookie Policy'>
			<CookiePolicy />
		</MainLayout>);
};
export default cookie;
const getServerSideProps = createNonLocalizedPageGetServerSideProps('/cookie-policy');

    async function __Next_Translate__getServerSideProps__1a1a20bb0ea__(ctx) {
      const res = await getServerSideProps(ctx)
      return {
        
        ...res,
        props: {
          ...(res.props || {}),
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/cookie-policy',
            loaderName: 'getServerSideProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getServerSideProps__1a1a20bb0ea__ as getServerSideProps }
  